import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useMemo, useRef } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Loader } from '../../../../Elements/Loader';
import { Tooltip } from '../../../../Feedback/Tooltip';
import { ANIMATION_DURATION_MS } from '../../constants';
import { useDropdownContext } from '../../context';
import { ClickableDropdownItemWrapper, LinkDropdownItemWrapper } from './styled';
export const DropdownItem = forwardRef(function DropdownItem({ children, id, icon, tooltip, wrap, isLoading, disabled, closeOnClick = true, last, onClick, to, dataTestId = 'dropdown-item' }, ref) {
    const { close } = useDropdownContext();
    const timeoutRef = useRef();
    const handleClick = useCallbackRef((e) => {
        e.stopPropagation();
        if (!isLoading && !disabled && onClick) {
            if (closeOnClick) {
                close();
                timeoutRef.current = window.setTimeout(() => {
                    onClick(e);
                }, ANIMATION_DURATION_MS);
            }
            else {
                onClick(e);
            }
        }
    });
    const containerProps = useMemo(() => ({
        id,
        wrap,
        disabled,
        last,
        onClick: onClick ? handleClick : undefined,
        to,
        'data-testid': dataTestId,
    }), [id, wrap, disabled, last, onClick, handleClick, to, dataTestId]);
    useEffect(() => () => {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }
    }, []);
    return (_jsxs(Tooltip, { tooltip: tooltip, placement: 'auto', ref: ref, ContainerComponent: to ? LinkDropdownItemWrapper : ClickableDropdownItemWrapper, containerComponentProps: containerProps, children: [icon, children, isLoading && _jsx(Loader, { cover: true })] }));
});
